import { render, staticRenderFns } from "./SchedulePoints.vue?vue&type=template&id=da48aea8"
import script from "./SchedulePoints.vue?vue&type=script&lang=js"
export * from "./SchedulePoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SchedulePoints.vue?vue&type=custom&index=0&blockType=i18n&locale=ru&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dem/Go/src/github.com/demget/quadroclub/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('da48aea8', component.options)
    } else {
      api.reload('da48aea8', component.options)
    }
    module.hot.accept("./SchedulePoints.vue?vue&type=template&id=da48aea8", function () {
      api.rerender('da48aea8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "site/src/views/schedule/SchedulePoints.vue"
export default component.exports